/**
 * USE BUSQUEDA AVANZADA - Hook para búsqueda transversal
 */

import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/query-client";
import {
  buscar,
  type BusquedaParams,
  type BusquedaResultado,
  type BusquedaOrden,
  type BusquedaExamen,
  type BusquedaPaginada,
} from "@/services/busqueda-avanzada";

export type { BusquedaParams, BusquedaResultado, BusquedaOrden, BusquedaExamen, BusquedaPaginada };

export function useBusquedaAvanzada(params: BusquedaParams | null) {
  return useQuery({
    queryKey: queryKeys.busquedaAvanzada.search(params),
    queryFn: ({ signal }) => buscar(params!, signal),
    enabled: params !== null,
    staleTime: 60_000,
  });
}
